import {
  CurrencyFlag,
  CurrencyFlagBox,
  CurrencyInputWrapper,
} from './components/currency-components'
import { MoneyField } from './components/money-field'
import { MoneyFieldProps } from './components/money-field.types'

export const CurrencyInput = (props: MoneyFieldProps) => {
  return (
    <CurrencyInputWrapper>
      <MoneyField {...props} />
      <CurrencyFlagBox>
        <CurrencyFlag currency={props.currency} />
      </CurrencyFlagBox>
    </CurrencyInputWrapper>
  )
}
